export default {
    methods: {
        getListHolders(arr) {
            const list = [];
            arr.forEach(el => {
                const fullName = el.full_name
                    ? ` ${el.full_name}`
                    : ` ${el.name} ${el.lastname_1 || ''} ${el.lastname_2 || ''}`;
                list.push(fullName);
            });
            return list.join(',');
        }
    }
};
